import { Link } from 'react-router-dom';

const News = () => {
  const newsItems = [
    {
      id: 1,
      category: 'Technology',
      title: 'Smart Manufacturing Trends and Implementation',
      date: 'June 17, 2025',
      image: 'https://public.readdy.ai/ai/img_res/bedff00213d6f52ac08908ef0f3655e3.jpg',
      slug: 'smart-manufacturing-trends-implementation'
    },
    {
      id: 2,
      category: 'Product Launch',
      title: 'New Gun Drilling System Achieves L/D400 Breakthrough',
      date: 'May 28, 2025',
      image: 'https://readdy.ai/api/search-image?query=Precision%20gun%20drilling%20machine%20with%20advanced%20spindle%20system%20drilling%20deep%20holes%20in%20metal%20workpiece%20with%20coolant%20flow%20in%20modern%20manufacturing%20facility%20with%20teal%20accent%20lighting&width=600&height=400&seq=homenews2&orientation=landscape',
      slug: 'gun-drilling-ld400-breakthrough'
    },
    {
      id: 3,
      category: 'Business',
      title: 'Partnership with Leading Medical Device Manufacturer',
      date: 'May 15, 2025',
      image: 'https://readdy.ai/api/search-image?query=Medical%20device%20manufacturing%20facility%20with%20precision%20surgical%20instruments%20and%20implants%20being%20machined%20on%20advanced%20equipment%20in%20sterile%20clean%20room%20environment%20with%20white%20and%20teal%20lighting&width=600&height=400&seq=homenews3&orientation=landscape',
      slug: 'medical-device-partnership'
    },
  ];

  return (
    <section id="news" className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-[#00D9C9] text-sm font-bold tracking-widest uppercase">Latest Updates</span>
          <h2 className="text-4xl lg:text-6xl font-bold text-[#001E3C] mt-4 mb-6">
            News & Stories
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {newsItems.map((item) => (
            <Link
              key={item.id}
              to={`/news/${item.slug}`}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-200"
            >
              <div className="relative h-[240px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-3 py-1 bg-[#00D9C9]/10 text-[#00D9C9] rounded-full text-xs font-semibold">
                    {item.category}
                  </span>
                  <span className="text-gray-500 text-xs">{item.date}</span>
                </div>
                <h3 className="text-xl font-bold text-[#001E3C] mb-3 group-hover:text-[#00D9C9] transition-colors duration-300">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 text-[#00D9C9] font-bold text-sm group-hover:gap-3 transition-all duration-300">
                  Read More
                  <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/news"
            className="inline-flex items-center gap-3 bg-[#00D9C9] text-[#001E3C] px-8 py-4 rounded-xl font-bold hover:bg-[#00F5E0] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            View All News
            <i className="ri-arrow-right-line text-xl w-6 h-6 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default News;
